<script setup lang="ts">
import { ref, onMounted, onUnmounted, watch, computed, reactive } from "vue";

import {
  loginWay,
  loginWayType,
  showLoginDialog,
  loginCodeUrl,
  validCode,
  verifyTime,
  closeLoginDialog,
  stopLoginPoll,
  getLoginCode,
  getVerifyCode,
  phoneLogin,
  getVerifyCodeAgain,
  openPrivacy,
  openAgreement,
} from "@/components/Dialogues/useData/login";
import { isCompactMode } from "@/data/pubilc";

const form = reactive({
  phoneNumber: "",
  code: "",
});

// const submit = (params: any) => {
//   getVerifyCodeAgain(form.phoneNumber, params);
// };
//手机模式，只有验证码登陆
const _loginWayType = ref(isCompactMode.value ? "手机号登录" : "扫码登录");

const dialogueDidClose = (done) => {
  closeLoginDialog();

  form.phoneNumber = "";
  form.code = "";
  _loginWayType.value = isCompactMode.value ? "手机号登录" : "扫码登录";

  done();
};

const ops = loginWay.map((item) => {
  return item.name;
});

watch(_loginWayType, (val) => {
  const value = _loginWayType.value;
  if (!showLoginDialog.value) {
    return;
  }
  if (value === "扫码登录") {
    loginWayType.value = 0;
    getLoginCode();
    console.log("发送二维码");
  } else {
    loginWayType.value = 1;
    stopLoginPoll();
    console.log("停止轮询");
  }
});

watch(loginWayType, (val) => {
  if (loginWayType.value == 1) {
    // stopLoginPoll();
    console.log("stopLoginPoll");
  } else {
    // getLoginCode();
    console.log("getLoginCode");
  }
});

const displayTitle = computed(() => {
  return verifyTime.value > 0 ? `重新获取(${verifyTime.value}s)` : "发送验证码";
});

const isRunning = computed(() => {
  return verifyTime.value > 0;
});
</script>

<template>
  <el-dialog
    v-model="showLoginDialog"
    width="400"
    class="custom"
    align-center
    center
    :destroy-on-close="true"
    :before-close="dialogueDidClose"
    :style="{ '--el-border-radius-base': '16px' }"
  >
    <template v-slot:header> </template>
    <div class="content">
      <el-segmented
        :style="{
          '--el-border-radius-base': '4px',
          '--el-segmented-item-selected-bg-color': '#4d6bfe',
        }"
        v-model="_loginWayType"
        :options="ops"
        size="default"
        v-if="!isCompactMode"
      />
      <div class="wxlogin" v-if="_loginWayType == '扫码登录'">
        <div class="code-box">
          <el-image
            style="width: 100%; height: 100%"
            :src="loginCodeUrl"
            :fit="`cover`"
          >
            <template #error>
              <div class="image-slot">
                <el-icon><icon-picture /></el-icon>
              </div>
            </template>
          </el-image>
          <div class="err-cover" v-if="!validCode" @click="getLoginCode">
            <div class="reload-bar">
              二维码已失效
              <div class="btn">重新获取</div>
            </div>
          </div>
        </div>
        <div class="title">微信扫一扫更方便</div>
        <div class="sub-title">
          <div class="info-bar">
            扫码登录表示您已同意
            <div class="link-btn" @click="openAgreement">《服务协议》</div>
            及
            <div class="link-btn" @click="openPrivacy">《隐私协议》</div>
          </div>
        </div>
      </div>
      <div class="phone-login" v-else>
        <div class="phone-input">
          <input
            maxlength="11"
            placeholder="请输入手机号"
            class="input"
            type="text"
            name=""
            id=""
            v-model="form.phoneNumber"
          />
          <div
            class="code-btn"
            :class="{
              disable: isRunning,
            }"
            @click="getVerifyCode(form.phoneNumber, 'login')"
          >
            <span class="text">
              {{ displayTitle }}
            </span>
          </div>
        </div>
        <div class="phone-input">
          <input
            class="input"
            placeholder="请输入验证码"
            type="text"
            name=""
            id=""
            v-model="form.code"
          />
        </div>
        <div class="primay-btn" @click="phoneLogin(form)">登录</div>
        <div class="info-bar">
          注册/登录表示您已同意
          <div class="link-btn" @click="openAgreement">《服务协议》</div>
          及
          <div class="link-btn" @click="openPrivacy">《隐私协议》</div>
        </div>
      </div>
    </div>
  </el-dialog>
</template>

<style lang="scss" scoped>
.content {
  width: 100%;
  height: 400px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 20px 10px;

  .wxlogin {
    width: 100%;
    height: 100%;

    display: flex;
    flex-direction: column;
    align-items: center;

    .code-box {
      position: relative;
      margin-top: 20px;
      margin-bottom: 20px;
      width: 200px;
      height: 200px;

      padding: 10px;
      border: 4px solid #4d6bfe;
      border-radius: 10px;

      .err-cover {
        z-index: 1;
        position: absolute;
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
        background-color: #2c3e5088;
        display: flex;
        justify-content: center;
        .reload-bar {
          font-size: 13px;
          color: #fff;
          display: flex;
          justify-content: center;
          align-items: center;
          gap: 4px;
          .btn {
            cursor: pointer;
            color: #4d6bfe;
          }
        }
      }
    }

    .title {
      font-size: 16px;
      margin-bottom: 10px;
    }

    .info-bar {
      flex: 1;

      display: flex;
      align-items: end;
      color: #8f90a7;
      font-size: 13px;
      gap: 5px;
      .link-btn {
        color: #4d6bfe;
        cursor: pointer;
      }
    }

    .sub-title {
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 13px;
      color: #8f90a7;
      gap: 5px;
      .icon {
        width: 14px;
        height: 14px;
      }
    }
  }

  .phone-login {
    width: 100%;
    height: 100%;

    display: flex;
    flex-direction: column;
    align-items: center;
    padding-top: 30px;
    padding-bottom: 20px;
    gap: 20px;

    .phone-input {
      width: 100%;
      height: 44px;
      padding: 12px;
      border: 1px solid #e5e5e5;
      border-radius: 12px;
      display: flex;
      align-items: center;
    }

    .input {
      font-size: 13px;
      height: 100%;
      outline: none;
      flex: 1;
      border: 0px solid #e5e5e5;
    }

    .code-btn {
      height: 100%;
      width: 90px;
      cursor: pointer;
      display: flex;
      align-items: center;
      justify-content: center;
      .text {
        font-size: 12px;
      }
    }

    .disable {
      cursor: not-allowed;
    }

    .primay-btn {
      margin-top: 30px;
      width: 100%;
      height: 44px;
      background: #4d6bfe;
      color: #fff;
      display: flex;
      align-items: center;
      justify-content: center;
      font-weight: bold;
      border-radius: 12px;
      cursor: pointer;

      &:hover {
        background: #4d6bfe99;
      }

      .disable {
        cursor: not-allowed;
        background: #4d6bfe99;
      }
    }

    .info-bar {
      flex: 1;

      display: flex;
      align-items: end;
      color: #8f90a7;
      font-size: 13px;
      gap: 5px;
      .link-btn {
        color: #4d6bfe;
        cursor: pointer;
      }
    }
  }
}
</style>
